import { Injectable, inject, signal } from "@angular/core";
import { Router } from "@angular/router";

type TableEntryMatcher = {
  path: string;
  code?: number[];
};
type TableEntry = {
  route: string;
  matchers: TableEntryMatcher[];
};
type RoutingTable = {
  [key: string]: TableEntry;
};

@Injectable({
  providedIn: "root",
})
export class ErrorRouter {
  private router = inject(Router);

  private url = signal("");
  private httpStatusCode = signal(0);

  // this configures what to do when an HTTP call fails
  // so no relation to the current page, just the requested URL
  private routingTable: RoutingTable = {
    support: {
      route: "support",
      matchers: [{ path: "/me", code: [500] }, { path: "/customers" }],
    },
    error: {
      route: "error",
      matchers: [{ path: "/graphql", code: [404, 500] }, { path: "/config" }],
    },
  };

  isValidTableEntry(key: string): boolean {
    const urlMatcher = (entry: TableEntryMatcher) => {
      const urlMatches = this.url().indexOf(entry.path) !== -1;
      if (!urlMatches) {
        return false;
      }
      if (!entry.code) {
        return urlMatches;
      }
      return urlMatches && entry.code.includes(this.httpStatusCode());
    };

    return (
      this.routingTable[key].matchers.map((entry) => urlMatcher(entry)).filter((value) => value === true).length > 0
    );
  }

  redirect(url: string, httpStatusCode: number): void {
    this.url.set(url);
    this.httpStatusCode.set(httpStatusCode);

    const acceptableRoutes = Object.keys(this.routingTable).filter((key) => this.isValidTableEntry(key));
    if (acceptableRoutes.length) {
      this.router.navigate([acceptableRoutes[0]]);
    }
  }
}
